<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    :ok-disabled="form.errors.any()"
    no-close-on-backdrop
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <b-col v-if="this.modal_acao == 'i'">
        <label>Alíquota Contribuinte</label>
        <currency-input
          class="form-control"
          v-model="icms_vigencia.aliquota_contribuinte"
          :auto-decimal-mode="true"
          placeholder="Alíquota contribuinte"
          :currency="{ prefix: '%' }"
          :distraction-free="getCurrency"
        />
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('icms_vigencia.aliquota_contribuinte')"
          v-if="form.errors.has('icms_vigencia.aliquota_contribuinte')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.modal_acao == 'i'">
        <label>Alíquota Não Contribuinte</label>
        <currency-input
          class="form-control"
          v-model="icms_vigencia.aliquota_nao_contribuinte"
          :auto-decimal-mode="true"
          placeholder="Alíquota não contribuinte"
          :currency="{ prefix: '%' }"
          :distraction-free="getCurrency"
        />
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('icms_vigencia.aliquota_nao_contribuinte')"
          v-if="form.errors.has('icms_vigencia.aliquota_nao_contribuinte')"
        ></b-form-feedback>
      </b-col>

      <b-col>
        <label>Mensagem legal contribuintee</label>
        <b-form-input
          type="text"
          placeholder="Mensagem legal contribuinte"
          v-model="form.msg_legal_contribuinte"
          name="msg_legal_contribuinte"
        >
        </b-form-input>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('msg_legal_contribuinte')"
          v-if="form.errors.has('msg_legal_contribuinte')"
        ></b-form-feedback>
      </b-col>
      <b-col>
        <label>Mensagem legal não contribuinte</label>
        <b-form-input
          type="text"
          placeholder="Mensagem legal não contribuinte"
          v-model="form.msg_legal_nao_contribuinte"
          name="msg_legal_nao_contribuinte"
        >
        </b-form-input>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('msg_legal_nao_contribuinte')"
          v-if="form.errors.has('msg_legal_nao_contribuinte')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.modal_acao == 'i'">
        <label>Alíquota FCP</label>
        <currency-input
          class="form-control"
          v-model="icms_vigencia.aliquota_pobreza"
          :auto-decimal-mode="true"
          placeholder="Alíquota FCP"
          :currency="{ prefix: '%' }"
          :distraction-free="getCurrency"
        />
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('icms_vigencia.aliquota_pobreza')"
          v-if="form.errors.has('icms_vigencia.aliquota_pobreza')"
        ></b-form-feedback>
      </b-col>

      <b-col>
        <label>UF Início</label>
        <multiselect
          v-model="ufInicioSelected"
          :options="optionsUf"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('uf_id_ini')"
          v-if="form.errors.has('uf_id_ini')"
        ></b-form-feedback>
      </b-col>
      <b-col>
        <label>UF Fim</label>
        <multiselect
          v-model="ufFimSelected"
          :options="optionsUf"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('uf_id_fim')"
          v-if="form.errors.has('uf_id_fim')"
        ></b-form-feedback>
      </b-col>
      <b-col>
        <label>Status</label>
        <multiselect
          v-model="statusSelected"
          :options="optionsLivStatus"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('status')"
          v-if="form.errors.has('status')"
        ></b-form-feedback>
      </b-col>
      <b-col>
        <label>Tipo ICMS</label>
        <multiselect
          v-model="tpIcmsSelected"
          :options="optionsLivTpIcms"
          track-by="value"
          label="label"
          :hide-selected="true"
          placeholder="Selecione"
          tag-placeholder="Selecionar"
          select-label="Selecionar"
          selected-label="Selecionado"
          deselect-label="Remover"
        ></multiselect>
        <b-form-feedback
          class="text-danger"
          v-text="form.errors.get('tp_icms')"
          v-if="form.errors.has('tp_icms')"
        ></b-form-feedback>
      </b-col>
      <b-col v-if="this.modal_acao == 'i'">
        <label>Data Inicial</label>
        <b-form-datepicker
          locale="pt-br"
          reset-button
          placeholder="Seleciona a data"
          v-model="icms_vigencia.dt_vigencia_ini"
          class="form-control"
          :date-format-options="{
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          }"
        >
        </b-form-datepicker>
      </b-col>
      <b-col v-if="this.modal_acao == 'i'">
        <label>Data Final</label>
        <b-form-datepicker
          locale="pt-br"
          reset-button
          placeholder="Seleciona a data"
          v-model="icms_vigencia.dt_vigencia_fim"
          class="form-control"
          :date-format-options="{
            day: 'numeric',
            month: 'numeric',
            year: 'numeric',
          }"
        >
        </b-form-datepicker>
      </b-col>
    </form>

    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="secondary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";
import moment from "moment";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      statusSelected: [],
      ufInicioSelected: [],
      ufFimSelected: [],
      tpIcmsSelected: [],
      optionsLivStatus: [],
      optionsUf: [],
      optionsLivTpIcms: [],
      activateDesativate: [],
      icms_vigencia: {},
      errors_array: [],
      helpForm: new Form({
        statusRecord: [],
        params: []
      }),
      form: new Form({
        msg_legal_contribuinte: "",
        msg_legal_nao_contribuinte: "",
        icms_vigencia: {},
        icms_id: "",
        tp_icms: "",
        uf_id_ini: "",
        uf_id_fim: "",
        status: ""
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    ufInicioSelected(obj) {
      this.form.uf_id_ini = obj.value;
    },
    ufFimSelected(obj) {
      this.form.uf_id_fim = obj.value;
    },
    tpIcmsSelected(obj) {
      this.form.tp_icms = obj.value;
    }
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.icms_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.errors_array = [];
      this.statusSelected = [];
      this.ufInicioSelected = [];
      this.ufFimSelected = [];
      this.tpIcmsSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.statusSelected = [];
      this.ufInicioSelected = [];
      this.ufFimSelected = [];
      this.tpIcmsSelected = [];
      this.form.reset();
      this.errors_array = [];
      this.form.msg_legal_contribuinte = data.msg_legal_contribuinte;
      this.form.msg_legal_nao_contribuinte = data.msg_legal_nao_contribuinte;
      this.ufInicioSelected = {
        label: data.uf_ini.nome,
        value: data.uf_ini.uf_id
      };
      this.ufFimSelected = {
        label: data.uf_fim.nome,
        value: data.uf_fim.uf_id
      };
      this.tpIcmsSelected = {
        label: data.tp_icms.descr,
        value: data.tp_icms.valor
      };
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      this.form.icms_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.icms_vigencia.status = 1;
      this.icms_vigencia.dt_vigencia_ini = this.formatDateSubmit(
        this.icms_vigencia.dt_vigencia_ini
      );
      this.icms_vigencia.dt_vigencia_fim = this.formatDateSubmit(
        this.icms_vigencia.dt_vigencia_fim
      );
      this.form.icms_vigencia = this.icms_vigencia;
      this.form
        .put("/api/" + this.rota + "/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      // this.icms_vigencia.status = 1;
      // this.icms_vigencia.dt_vigencia_ini = this.formatDateSubmit(
      //   this.icms_vigencia.dt_vigencia_ini
      // );
      // this.icms_vigencia.dt_vigencia_fim = this.formatDateSubmit(
      //   this.icms_vigencia.dt_vigencia_fim
      // );
      // this.form.icms_vigencia = this.icms_vigencia;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.metodo();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/icms/jsonlistgeral")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });
          response.uf.forEach(obj => {
            this.optionsUf.push({ label: obj.nome, value: obj.uf_id });
          });
          response.tp_icms.forEach(obj => {
            this.optionsLivTpIcms.push({ label: obj.descr, value: obj.valor });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
